
import pdf from 'vue-pdf';
import AdsApi from '../../libs/ads-request/ads-api';

export default {
  name: 'ShowPdf',
  components: {
    pdf,
  },
  data: () => ({
    orderIdDms: '',
    base64: '',
    show: false,
  }),
  computed: {
    mobile() {
      return this.$q.screen.lt.md;
    },
  },
  mounted() {
    this.initialCharge();
  },
  methods: {
    getInvoicePdf() {
      this.loaderShow('Obteniendo PDF');

      AdsApi.getInvoiceParams(this.orderIdDms)
        .then((response) => {
          const { data } = response;

          this.base64 = `data:application/pdf;base64,${encodeURI(data.pdfFile)}`;

          this.show = true;
        })
        .catch((err) => this.alertShow(err, 'error'))
        .then(this.loaderHide);
    },
    initialCharge() {
      this.orderIdDms = this.$route.params.orderIdDms;
      this.getInvoicePdf();
    },
  },
};
